export default "__VITE_ASSET__7lfGYjgC__"